var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Header'),_c('Banner'),_c('About'),_c('Mango'),_c('OurProducts'),_c('Gallery'),_c('Branches'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }